import React from "react";
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {TrackingCarrierDetails} from "./TrackingCarrierDetails";
import {TrackingShipmentRoute} from "./TrackingShipmentRoute";

export const TrackingShipmentSummary = ({result}) => {
    const theme = useTheme();
    return (
        <Box sx={{borderRadius: `${theme.shape.lg}px`, overflow: "hidden", boxShadow: theme.shadows[1]}}>
            <TrackingShipmentRoute result={result} />
            <Box sx={{backgroundColor: "background.paper", px: {xs: 1.5, sm: 2, md: 2.5}, pb: {xs: 1.5, sm: 2, md: 2.25}}}>
                <TrackingCarrierDetails result={result} />
            </Box>
        </Box>
    );
};
